import React from "react";
import "./ShopBtn.css";

function ShopBtn() {
  return (
    <div className="ShopBtn">
      <button className="ShopBtn-btn">SHOP NOW</button>
    </div>
  )
}

export default ShopBtn;